import React from "react";
import styles from "../../Form/styles";
import { withStyles } from "@material-ui/core/styles";
import CustomTextField from "../../../../common/CustomTextField";
import {
  MAX_VALUE_CONSTRAINTS,
  MIN_VALUE,
} from "../../../../common/constants";
import {ONLY_NUMBER_REGEX} from "../../../../../constRegex"

class DeliveryExceptionSaia extends React.Component {
  handleChange = (name) => (value) => {
    const { handleChange } = this.props;
    value = Number(value);
    handleChange && handleChange(name)(value);
  };

  render() {
    const { classes } = this.props;
    const { editInfo, errorInfo } = this.props;
    return (
      <CustomTextField
        id="adeNumber"
        label="ADE Number"
        handleChange={this.handleChange("adeNumber")}
        error={errorInfo.adeNumber}
        value={editInfo.adeNumber}
        className={classes.fullWidth}
        inputProps={{
          min: MIN_VALUE.DELIVERY_PRO_FORM.ADE_NUMBER,
          max: MAX_VALUE_CONSTRAINTS.DELIVERY_PRO_FORM.ADE_NUMBER,
          pattern: ONLY_NUMBER_REGEX,
        }}
        hideIncrementer
      />
    );
  }
}

export default withStyles(styles)(DeliveryExceptionSaia);
